import { breakpoints } from "@carbon/layout";
import { adminAiHref, adminHref } from "@/lib/ui/admin";
import { agentsCopy, agentsHref } from "@/lib/ui/agents";
import { chatHistoryCopy } from "@/lib/ui/chat-history";
import {
  adminChannelTranscriptsHref,
  channelsCopy,
} from "@/lib/ui/channels";

export type AppNavId =
  | "home"
  | "search"
  | "chat"
  | "documents"
  | "wiki"
  | "agents"
  | "transcripts";

export type AppNavItem = {
  id: AppNavId;
  href: string;
  label: string;
};

const MAIN_NAV: AppNavItem[] = [
  { id: "home", href: "/", label: "Главная" },
  { id: "documents", href: "/documents", label: "Документы" },
  { id: "search", href: "/search", label: "Поиск" },
  { id: "wiki", href: "/wiki", label: "Wiki" },
  { id: "agents", href: agentsHref(), label: agentsCopy.nav },
  { id: "chat", href: "/chat", label: chatHistoryCopy.nav },
];

export function isNavActive(pathname: string, href: string): boolean {
  if (href === "/") {
    return pathname === "/";
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}

export function isAdminNavActive(pathname: string): boolean {
  if (isNavActive(pathname, adminChannelTranscriptsHref())) {
    return false;
  }
  return isNavActive(pathname, adminHref()) || pathname.startsWith(adminAiHref());
}

export function canAccessAdmin(access: {
  canManageUsers: boolean;
  canManageAi: boolean;
  canAuditMessenger?: boolean;
}): boolean {
  return (
    access.canManageUsers ||
    access.canManageAi ||
    Boolean(access.canAuditMessenger)
  );
}

export function canShowAdminMenu(access: {
  canManageUsers: boolean;
  canManageAi: boolean;
  canInspectAccess?: boolean;
}): boolean {
  return (
    access.canManageUsers ||
    access.canManageAi ||
    Boolean(access.canInspectAccess)
  );
}

export const SIDENAV_COOKIE = "pinwiki_sidenav";

/** Carbon styles `breakpoint-down('lg')`: lg width minus 0.02rem. */
export const SIDE_NAV_OVERLAY_MEDIA = `(max-width: ${
  Number.parseFloat(breakpoints.lg.width) - 0.02
}rem)`;

export function parseSideNavExpanded(raw: string | null | undefined): boolean {
  return raw !== "COLLAPSED";
}

export function sideNavExpandedInViewport(
  savedExpanded: boolean,
  overlay: boolean,
): boolean {
  return overlay ? false : savedExpanded;
}

export function sideNavCookieValue(expanded: boolean): "EXPANDED" | "COLLAPSED" {
  return expanded ? "EXPANDED" : "COLLAPSED";
}

export function appNavItems(access?: {
  canAuditMessenger?: boolean;
}): AppNavItem[] {
  if (!access?.canAuditMessenger) {
    return MAIN_NAV;
  }
  const items = [...MAIN_NAV];
  const chatIndex = items.findIndex((item) => item.id === "chat");
  items.splice(chatIndex, 0, {
    id: "transcripts",
    href: adminChannelTranscriptsHref(),
    label: channelsCopy.transcriptsNav,
  });
  return items;
}
